<signup-success-form
  (navigateToSignupVerify)="navigateToSignupVerify()"
  [appName]="appName"
></signup-success-form>